module.exports = (fox, _) => ({
	app_initialized() {
		const { paid, private: privateShow } = this.connectParams;
		const ppmEnabled = !!fox.getEnv('public.ppmEnabled');
		const _private = privateShow || paid;

		if (this.controller.type === 'webrtc')
			this.status = _.STATUS_CONNECTED;

		if (ppmEnabled && _private && this.checkTrustedHash())
			return this.startPlay();

		if (!this.isAllowed()) {
			this._bindData.isRequester = false;
			if (!this.controller.isAppleBrowser)
				this.manageStatusBanners(_private ? 'private' : 'progress');

			this.switchTabs('fakeChat');

			if (!_private)
				this.connectToChat();

			return false;
		}

		if (ppmEnabled && _private && !this.checkTrustedHash()) {
			this.switchTabs('chat');
			this.rwom1('#paidEntry').setTemplateOptions({
				paidType: privateShow ? 1 : paid ? 2 : 0,
				amount: this.settings.amount,
				period: this.settings.period
			});

			this.switchEmbeddedWidget('paidEntry');

			return false;
		}

		return this.startPlay();
	},

	stream_connection_success() {
		if (this.controller.type !== 'webrtc')
			this.status = _.STATUS_CONNECTED;

		this.connectSuccess();
		this.toggleMessageBlock();
	},

	stream_connection_closed() {
		if (this.isDisconnected())
			return false;

		if (this.manualDisconnect) {
			delete this.manualDisconnect;
			this.status = _.STATUS_DISCONNECTED;

			return this.manageStatusBanners('done');
		}

		clearTimeout(this.waitForDone);
		this.waitForDone = setTimeout(() => {
			this.leaveLiveshow(true);
			this.treatError({ id: this.getInterruptError() });
		}, _.TIMER_WAIT_FOR_DONE);
	},

	stream_viewer_play_started() {
		clearTimeout(this.waitForDone);
		this.manageStatusBanners(false);

		const savedLevel = fox.utils.localStorage('getItem', '_lsvl_');
		this.toggleButton(_.DOM_SELECTOR_VOLUMEBTN);
		this.toggleButton(_.DOM_SELECTOR_FULLSCREEN);

		if (!this.__privateRequestTimer)
			this.toggleGoPrivateBtn(false);

		if (savedLevel)
			this.controller.setVolume(Number(savedLevel));

		if (this.connectParams.private) {
			this.setChatMessage({
				type: 4,
				text: 'intro'
			});
		}

		this.setUiVolumeLevel(this.controller.getVolume() * 100);
	},

	stream_viewer_play_stopped() {
		this.toggleButton(_.DOM_SELECTOR_VOLUMEBTN, true);
		this.toggleGoPrivateBtn(true);
		this.toggleButton(_.DOM_SELECTOR_FULLSCREEN, true);
	},

	stream_viewer_metadata(args) {
		this.setFlashSize(this.setStreamInfo(args.desc));
	}
})


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/widget/mixins/translatorCallbacks.es.js